import { frameBuf } from "./Capture";

class GLRenderer {
  constructor() {
    this.glCtx = undefined;
    this.texRef = undefined;
    this.samplerRef = undefined;
    this.enhanceColorRef = undefined;
    this.enhanceColor = 0.0;
    this.vertexPosBuffer = undefined;
    this.verteices = new Float32Array([1, 1, -1, 1, 1, -1, -1, -1]);
    this.zoom = 1.0;
  }
  setupGL(canvas) {
    var validContextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"];
    let glCtx;
    if (glCtx) {
      var loseContextExt = glCtx.getExtension("WEBGL_lose_context");
      if (loseContextExt) {
        loseContextExt.loseContext();
      }
    }
    for (var id in validContextNames) {
      try {
        glCtx = canvas.getContext(validContextNames[id]);
      } catch (e) {
        glCtx = null;
      }
      if (!glCtx || typeof glCtx.getParameter !== "function") {
        glCtx = null;
      }
      if (glCtx) {
        break;
      }
    }
    if (!glCtx) return;
    var vertexShaderScript = [
      "attribute vec4 vertexPos;",
      "attribute vec4 texturePos;",
      "varying vec2 textureCoord;",
      "void main()",
      "{",
      "gl_Position = vertexPos;",
      "textureCoord = texturePos.xy;",
      "}"
    ].join("\n");

    var fragmentShaderScript = [
      "precision highp float;",
      "vec3 rgb2hsv(vec3 c)",
      "{",
      "vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);",
      "vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));",
      "vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));",
      "float d = q.x - min(q.w, q.y);",
      "float e = 1.0e-10;",
      "return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);",
      "}",
      "vec3 hsv2rgb(vec3 c)",
      "{",
      "vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);",
      "vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);",
      "return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);",
      "}",
      "varying highp vec2 textureCoord;",
      "uniform float enhance_color;",
      "uniform sampler2D sampler;",
      "void main(void) {",
      "vec4 color = texture2D(sampler,  textureCoord);",
      "vec3 chsv = rgb2hsv(color.rgb);",
      "chsv.g = chsv.g*(1.0+enhance_color);",
      "vec3 crgb = hsv2rgb(chsv);",
      "color = vec4(crgb.b, crgb.g, crgb.r, 1.0);",
      "gl_FragColor = color;",
      "}"
    ].join("\n");
    // 'color = vec4(crgb.b*1.0655, crgb.g, crgb.r*1.400, 1.0);',

    var vertexShader = glCtx.createShader(glCtx.VERTEX_SHADER);
    glCtx.shaderSource(vertexShader, vertexShaderScript);
    glCtx.compileShader(vertexShader);
    if (!glCtx.getShaderParameter(vertexShader, glCtx.COMPILE_STATUS)) {
    }

    var fragmentShader = glCtx.createShader(glCtx.FRAGMENT_SHADER);
    glCtx.shaderSource(fragmentShader, fragmentShaderScript);
    glCtx.compileShader(fragmentShader);
    if (!glCtx.getShaderParameter(fragmentShader, glCtx.COMPILE_STATUS)) {
    }

    var program = glCtx.createProgram();
    glCtx.attachShader(program, vertexShader);
    glCtx.attachShader(program, fragmentShader);
    glCtx.linkProgram(program);
    if (!glCtx.getProgramParameter(program, glCtx.LINK_STATUS)) {
    }

    glCtx.useProgram(program);
    this.vertexPosBuffer = glCtx.createBuffer();
    glCtx.bindBuffer(glCtx.ARRAY_BUFFER, this.vertexPosBuffer);
    glCtx.bufferData(glCtx.ARRAY_BUFFER, this.verteices, glCtx.STATIC_DRAW);

    var vertexPosRef = glCtx.getAttribLocation(program, "vertexPos");
    glCtx.enableVertexAttribArray(vertexPosRef);
    glCtx.vertexAttribPointer(vertexPosRef, 2, glCtx.FLOAT, false, 0, 0);

    var texturePosBuffer = glCtx.createBuffer();
    glCtx.bindBuffer(glCtx.ARRAY_BUFFER, texturePosBuffer);
    glCtx.bufferData(
      glCtx.ARRAY_BUFFER,
      new Float32Array([1, 0, 0, 0, 1, 1, 0, 1]),
      glCtx.STATIC_DRAW
    );
    // glCtx.bufferData(glCtx.ARRAY_BUFFER, new Float32Array([0, 1, 1, 1, 0, 0, 1, 0]), glCtx.STATIC_DRAW)

    var texturePosRef = glCtx.getAttribLocation(program, "texturePos");
    glCtx.enableVertexAttribArray(texturePosRef);
    glCtx.vertexAttribPointer(texturePosRef, 2, glCtx.FLOAT, false, 0, 0);

    this.samplerRef = glCtx.getUniformLocation(program, "sampler");
    this.enhanceColorRef = glCtx.getUniformLocation(program, "enhance_color");

    this.texRef = glCtx.createTexture();
    glCtx.bindTexture(glCtx.TEXTURE_2D, this.texRef);
    glCtx.texParameteri(glCtx.TEXTURE_2D, glCtx.TEXTURE_MAG_FILTER, glCtx.LINEAR);
    glCtx.texParameteri(glCtx.TEXTURE_2D, glCtx.TEXTURE_MIN_FILTER, glCtx.LINEAR);
    glCtx.texParameteri(glCtx.TEXTURE_2D, glCtx.TEXTURE_WRAP_S, glCtx.CLAMP_TO_EDGE);
    glCtx.texParameteri(glCtx.TEXTURE_2D, glCtx.TEXTURE_WRAP_T, glCtx.CLAMP_TO_EDGE);
    glCtx.bindTexture(glCtx.TEXTURE_2D, null);

    glCtx.uniform1i(this.samplerRef, 0);
    glCtx.uniform1f(this.enhanceColorRef, this.enhanceColor);
    this.glCtx = glCtx;
  }

  deleteGL() {
    if (this.glCtx) {
      this.glCtx.deleteTexture(this.texRef);
      this.glCtx.deleteProgram(this.program);
      this.glCtx.deleteBuffer(this.texturePosBuffer);
      this.glCtx.deleteShader(this.fragmentShader);
      this.glCtx.deleteShader(this.vertexShader);
      var loseContextExt = this.glCtx.getExtension("WEBGL_lose_context");
      if (loseContextExt) {
        loseContextExt.loseContext();
      }
      this.glCtx = null;
    }
  }
  drawFrame(width, height, glCtx) {
    let w = width;
    let h = height;
    if (this.glCtx) {
      glCtx.activeTexture(glCtx.TEXTURE0);
      glCtx.bindTexture(glCtx.TEXTURE_2D, this.texRef);
      glCtx.uniform1i(this.samplerRef, 0);
      glCtx.uniform1f(this.enhanceColorRef, this.enhanceColor);
      glCtx.texImage2D(
        glCtx.TEXTURE_2D,
        0,
        glCtx.RGBA,
        w,
        h,
        0,
        glCtx.RGBA,
        glCtx.UNSIGNED_BYTE,
        frameBuf
      );
      glCtx.drawArrays(glCtx.TRIANGLE_STRIP, 0, 4);
    }
  }
  setZoom(x, y, zoom) {
    var zlt = zoom / this.zoom;
    if (zoom < 1.0 || zoom > 3.0) return;
    // new Float32Array([1, 1, -1, 1, 1, -1, -1, -1]);
    var wl = x - this.verteices[2];
    var ht = this.verteices[1] - y;
    wl = zlt * wl;
    ht = zlt * ht;
    var xl = x - wl;
    var yt = y + ht;
    if (xl > -1.0) {
      xl = -1.0;
    }
    if (yt < 1.0) {
      yt = 1.0;
    }
    var xr = xl + zoom * 2.0;
    var yb = yt - zoom * 2.0;
    if (xr < 1.0) {
      xr = 1.0;
      xl = xr - zoom * 2.0;
    }
    if (yb > -1.0) {
      yb = -1.0;
      yt = yb + zoom * 2.0;
    }
    this.verteices[0] = xr;
    this.verteices[1] = yt;
    this.verteices[2] = xl;
    this.verteices[3] = yt;
    this.verteices[4] = xr;
    this.verteices[5] = yb;
    this.verteices[6] = xl;
    this.verteices[7] = yb;
    this.zoom = zoom;
    let glCtx = this.glCtx;
    glCtx.bindBuffer(glCtx.ARRAY_BUFFER, this.vertexPosBuffer);
    glCtx.bufferData(glCtx.ARRAY_BUFFER, this.verteices, glCtx.STATIC_DRAW);
  }
}

export default GLRenderer;



// WEBPACK FOOTER //
// ./src/mainInterface/js/GLRenderer.js